import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { UiFormModule } from "../../../shared/ui/ui-form.module";
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { RouterModule } from "@angular/router";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";

import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { CashListComponent } from "./components/cash-list/cash-list.components";
import { CashDetailPanelComponent } from "./components/cash-detail-panel/cash-detail-panel.component";
import { CashFormDialogComponent } from "./components/cash-form-dialog/cash-form-dialog.component";
import { CashReducer } from "./store/reducers/cash.reducer";
import { CashService } from "./services/cash.service";
import { CashEffects } from "./store/effects/cash.effects";
import { SharedModule } from "../../shared/shared.module";

@NgModule({
  declarations:[
    CashListComponent,
    CashDetailPanelComponent,
    CashFormDialogComponent,
  ],
  exports:[
    CashListComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    UiFormModule,
    SharedModule,
    RouterModule,
    FormsModule,

    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatTableModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatToolbarModule,
    MatCardModule,
    MatDividerModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatSnackBarModule,

    StoreModule.forFeature('cash', CashReducer),
    EffectsModule.forFeature([CashEffects])
  ],
  providers: [
    CashService
  ]
})

export class CashModule { }
